import React, { useEffect, useState, useRef } from "react";
import { withRouter } from "react-router";
import classnames from "classnames";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";

import * as actions from "../../../../store/actions";
import "./index.css";
import { VALIDATE_ACH_BANK_DETAILS } from "../../../../store/actions/actionTypes";
import constants, { getOnboardingPath } from "../../../../constants";

import Row from "../../../../components/uiElements/grid/Row";
import Card from "../../../../layout/Onboarding/Card";
import Col from "../../../../components/uiElements/grid/Col";
import PaymentModal from "./PaymentModal";
import Button from "../../../../components/formElements/button/Button";
import OnboardingIcon from "../../../../components/uiElements/icons/onboardingIcons/OnboardingIcon";
import moment from "moment";
import ProfileIcon from "../../../../components/uiElements/icons/profileIcons/ProfileIcon";
import Modals from "../../../../components/uiElements/popupModal/modal";
import {
  VALIDATE_SUBSCRIPTION,
  REMOVE_VALIDATIONS,
} from "../../../../store/actions/actionTypes";
import { toast } from "react-toastify";

const InfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    class="bi bi-info-circle"
    viewBox="0 0 16 16"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
  </svg>
);

const StepSix = ({
  setAccountDetails,
  accountDetails,
  redirectedPath,
  history,
  getSubscriptionPlanList,
  addSubscriptionPlan,
  cancelSubscription,
  is_subscription_exists,
  validateSubscription,
  form,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [upgradeModal, setUpgradeModal] = useState(false);
  const myRef = useRef();

  useEffect(() => {
    if (form && form.isSubscriptionExist) {
      getSubscriptionPlanList();
      //eslint-disable-next-line
    } else if (form.isSubscriptionExist === false) {
      myRef?.current?.querySelector(":invalid")?.scrollIntoView({
        behavior: "smooth",
      });
    } else {
      getSubscriptionPlanList();
      // eslint-disable-next-line
    }

    form.isSubscriptionExist = false;
    toast.error(form.subscriptionExist, {
      position: constants.TOAST_POSITION,
    });

    form.personalInfo = false;
    // eslint-disable-next-line
  }, [form]);

  const onPurchaseSubscription = subscription => {
    setAccountDetails({
      selectedSubscription: subscription,
    });
    setIsOpen(true);
  };
  

  const { selectedSubscription, subscription, subscriptions } = accountDetails;
  return (
    <>
      <Modals
        title="Cancel Subscription"
        isOpen={confirmModal}
        styles={{
          content: {
            minWidth: "500px",
            maxWidth: "500px",
            minHeight: "320px",
            maxHeight: "320px",
          },
        }}
        btnDark={{
          label: "Cancel",
          onclick: () => {
            cancelSubscription(subscription?.id);
            setConfirmModal(false);
          },
        }}
        btnOutline={{
          label: "Close",
          onclick: () => {
            setConfirmModal(false);
          },
        }}
      >
        <p className="mx-auto text-center denyAppointmentText">
          Are you sure you want to cancel subscription?{" "}
        </p>
      </Modals>
      <PaymentModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onPayment={type =>
          addSubscriptionPlan(
            selectedSubscription?.price_id?.id,
            type,
            (redirect = undefined) => {
              // if (redirect) window.open(redirect, "_target");
              setIsOpen(false);
            }
          )
        }
        allowBankDebit={true}
        title="Purchase Subscription"
      />

      <Modals
        title="Upgrade Subscription"
        isOpen={upgradeModal}
        styles={{
          content: {
            minWidth: "500px",
            maxWidth: "500px",
            minHeight: "320px",
            maxHeight: "320px",
          },
        }}
        btnDark={{
          label: "Cancel",
          onclick: () => {
            cancelSubscription(subscription?.id);
            setConfirmModal(false);
          },
        }}
        btnOutline={{
          label: "Close",
          onclick: () => {
            setUpgradeModal(false);
          },
        }}
      >
        <p className="mx-auto text-center denyAppointmentText">Uprade Plan</p>
      </Modals>

      <div className={classnames("onboarding-container")}>
        <p className="onboarding-header">Purchase Subscription</p>
        <Row>
          {![
            "trialing",
            "active",
            "canceled",
            "incomplete",
            "past_due",
          ].includes(subscription?.status) && (
            <p style={{ textAlign: "justify", textJustify: "interWord" }}>
              <InfoIcon /> You are getting a free trial for a month. Post free
              trial you will be charged as per the plan you choose.
            </p>
          )}

          {subscriptions?.map(sub => (
          <Card
              className={classnames("subscription-card pb-5")}
              style={{
                background:
                  ["trialing", "active", "canceled"].includes(sub?.status) &&
                  "var(--faint-color)",
              }}
            >
              <Row className="mb-4 mt-n4 p-2">
                <Col
                  size={["md-8"]}
                  className={
                    ["trialing", "active", "canceled"].includes(sub?.status) &&
                    sub?.current_period_end * 1000 > new Date().getTime() &&
                    "disable"
                  }
                >
                  <div onClick={() => onPurchaseSubscription(sub)}>
                    {" "}
                    <p>
                      <sup
                        className="card-content"
                        style={{
                          verticalAlign: "super",
                        }}
                      >
                        $
                      </sup>{" "}
                      <span
                        className="card-content"
                        style={{
                          fontSize: 35,
                        }}
                      >
                        {sub?.unit_amount}
                      </span>
                      <span className="card-content">
                        {" /"}
                        {sub?.recurring?.interval
                          ? sub?.recurring?.interval.charAt(0).toUpperCase() +
                            sub?.recurring?.interval.slice(1)
                          : sub?.price_id?.recurring?.interval
                              .charAt(0)
                              .toUpperCase() +
                            sub?.price_id?.recurring?.interval.slice(1)}{" "}
                      </span>
                      <p>{sub?.product?.description}</p>
                    </p>
                  </div>
                </Col>
                {["trialing", "active"].includes(sub?.status) && sub?.id && (
                  <Col size={["md-4"]}>
                    <span data-tip onClick={() => setConfirmModal(true)}>
                      <ProfileIcon className="float-right" type="danger" />
                      <ReactTooltip>Cancel Subscription</ReactTooltip>
                    </span>
                  </Col>
                )}
                {sub?.product?.name === "Free Plan" &&
                <Col size={["md-12"]}>
                  <p className="mt-3">
                    <InfoIcon />{" "}
                    <span
                      className={
                        sub?.status === "incomplete" && "text-danger"
                      }
                    >
                      Suggested plan for Concierge Service
                    </span>
                  </p>
                </Col>
                }
                {sub?.status && sub?.status !== "incomplete" && (
                  <Col size={["md-12"]}>
                    <p className="mt-3">
                      <InfoIcon />{" "}
                      <span
                        className={
                          sub?.status === "incomplete" && "text-danger"
                        }
                      >
                        {subscription?.status === "active" &&
                          `Next Billing date is ${moment(
                            sub?.current_period_end * 1000
                          ).format("MMMM DD, yyyy")}`}
                        {subscription?.status === "canceled" &&
                          `Expires on ${moment(
                            sub?.current_period_end * 1000
                          ).format("MMMM DD, yyyy")}`}
                        {sub?.status === "trialing" &&
                          `You are getting a free trial for a month. Post free
                          trial you will be charged as per the plan you choose. Trial Period Ends on ${moment(
                            sub?.trial_end * 1000
                          ).format("MMMM DD, yyyy")}`}{" "}
                        {sub?.status === "past_due" && `Subscription is ended`}
                      </span>
                    </p>
                  </Col>
                )}
              </Row>
            </Card>
          ))}
          {subscription?.status === "incomplete" && (
            <span
              style={{
                textAlign: "left",
                color: "var(--font-color)",
              }}
            >
              <span className="font-weight-bold">Payment Status:</span>
              {` Subscription payment incomplete due to payment method requires additional authentication. Please`}
              <span
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
                className="pl-2"
                onClick={() =>
                  window.open(subscription?.hosted_invoice_url, "_target")
                }
              >
                click here
              </span>
              &nbsp;{` to complete the payment`}
            </span>
          )}
          {!redirectedPath && (
            <Button
              type="secondary"
              indicatorButton
              className={classnames("float-right next-button")}
              label={<OnboardingIcon type="nextButton" />}
              onClick={() =>
                is_subscription_exists == undefined ||
                is_subscription_exists === false
                  ? validateSubscription(is_subscription_exists)
                  : history.push(getOnboardingPath("/profile-complete"))
              }
            />
          )}
        </Row>
        {/* <Row>
        <div>
          <div className="StripeElement subscription-note-card">
            Note: To activate the concierge service for a patient, you need to select the <strong>$0/Month</strong> subscription.
          </div>
        </div>
        </Row> */}
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, auth, validation }) => ({
  accountDetails: onboarding?.accountDetails,
  form: validation.data,
  redirectedPath: auth.redirectToOnboardingPath,
  is_subscription_exists: onboarding.accountDetails?.is_subscription_exists,
});

const mapDispatchToProps = dispatch => ({
  addAccount: cb => dispatch(actions.addAccount(cb)),
  retrieveBankAccount: cb => dispatch(actions.retrieveBankAccount(cb)),
  generateBankAccountToken: cb =>
    dispatch(actions.generateBankAccountToken(cb)),
  setAccountDetails: updatedData =>
    dispatch(actions.setAccountDetails(updatedData)),
  generateACHBankAccountToken: cb =>
    dispatch(actions.generateACHBankAccountToken(cb)),
  validateData: achBankdetails =>
    dispatch(actions.validateData(VALIDATE_ACH_BANK_DETAILS, achBankdetails)),
  verifyBankAccount: cb => dispatch(actions.verifyBankAccount(cb)),
  getSubscriptionPlanList: () => dispatch(actions.getSubscriptionPlanList()),
  addSubscriptionPlan: (price_id, type, cb) =>
    dispatch(actions.addSubscriptionPlan(price_id, type, cb)),
  cancelSubscription: (subscription_id, cb) =>
    dispatch(actions.cancelSubscription(subscription_id, cb)),
  validateSubscription: sign =>
    dispatch(actions.validateSubscription(VALIDATE_SUBSCRIPTION, sign)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(StepSix)
);
